module.exports = __webpack_public_path__ + "static/media/barber.57538b80.jpg";